import React, { ReactElement } from 'react'
import Template from '../../HelperClass/Template/Row'
import { BaseballRowProps } from '../../HelperClass/StandingsRowTypes'
import MatchCounter from '../../HelperClass/MatchCounter'
import ResultCounter from '../../HelperClass/ResultCounter'
import Percent from '../../HelperClass/Percent'
import GamesBehind from '../../HelperClass/GamesBehind'
import Streak from '../../HelperClass/Streak'

export type Props = BaseballRowProps

const BaseballRow = ({
    onRowPress,
    rank,
    tendency,
    onMorePress,
    leagueQualifierColor,
    competitorLogoUrl,
    competitorName,
    competitorLogoAlt,
    hasDivider,
    imageType,
    additionalInfoLabel,
    testID,
    matchCounter,
    lossCounter,
    winCounter,
    gb,
    streak,
    percent,
    isCompetitorBold,
}: Props): ReactElement => {
    return (
        <Template
            rank={rank}
            testID={testID}
            tendency={tendency}
            onRowPress={onRowPress}
            competitorLogoUrl={competitorLogoUrl}
            leagueQualifierColor={leagueQualifierColor}
            onMorePress={onMorePress}
            competitorName={competitorName}
            additionalInfoLabel={additionalInfoLabel}
            competitorLogoAlt={competitorLogoAlt}
            hasDivider={hasDivider}
            imageType={imageType}
            isCompetitorBold={isCompetitorBold}
        >
            <MatchCounter matchCounter={matchCounter} width={20} />
            <ResultCounter
                format="WL"
                lossCounter={lossCounter}
                winCounter={winCounter}
                width={44}
            />
            <Percent percent={percent} width={40} />
            <GamesBehind gb={gb} width={27} />
            {streak ? <Streak streak={streak} /> : null}
        </Template>
    )
}

export default BaseballRow
